module.exports = __webpack_public_path__ + "static/media/release.c79ed969.png";